export const securityLevel = {
    'high': 3,
    'medium': 2,
    'low': 1,
};